import { createContext, useState, useEffect } from "react";
import api from "../services/api";
import { toast } from "react-toastify";

export const AuthContext = createContext();

export default function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loadingAuth, setLoadingAuth] = useState(true);

    // EFEITO: Toda vez que a página recarregar, checa se o cara ainda tem permissão
    useEffect(() => {
        async function checkLogin() {
            const token = localStorage.getItem("@maxtramidia:token");
            const userStorage = localStorage.getItem("@userFirebase");

            if (token && userStorage) {
                // Injeta o token no Header para o middleware 'isAuthenticated' deixar passar
                api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

                try {
                    // Bate na sua rota router.get("/me") para pegar os dados fresquinhos do usuário
                    const response = await api.get("/me");
                    
                    // Atualiza o estado com os dados do usuário do banco!
                    setUser(response.data);
                } catch (error) {
                    console.error("Sessão expirada. Por favor, faça login novamente.");
                    signOut();
                }
            } else {
                setUser(null);
            }

            setLoadingAuth(false);
        }

        checkLogin();
    }, []);

 
        async function signIn(email, password) {
        try {
            const response = await api.post("/sessions", { email, password });

            // 👇 Agora inclui companyId e plan
            const { id, name, email: userEmail, companyId, role, plan, token } = response.data;

            const userData = { id, name, email: userEmail, companyId, role, plan };

            setUser(userData);
            api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
            localStorage.setItem("@maxtramidia:token", token);
            localStorage.setItem("@userFirebase", JSON.stringify(userData));

            return true;
        } catch (error) {
            const mensagemErro = error.response?.data?.error || "Erro ao fazer login.";
            toast.error(mensagemErro);
            return false;
        }
    }


    // FUNÇÃO: Sair do sistema
    function signOut() {
        localStorage.removeItem("@maxtramidia:token");
        localStorage.removeItem("@userFirebase");
        delete api.defaults.headers.common["Authorization"]; // Tira o token do Axios
        setUser(null);
    }

    // Mantido para compatibilidade com partes antigas do seu front-end
    function handleInfoUser(userData) {
        setUser(userData);
    }

    return (
        <AuthContext.Provider 
            value={{
                signed: !!user,
                loadingAuth,
                user,
                userFirebase: user, 
                signIn,
                signOut,
                handleInfoUser,
                setUserFirebase: setUser 
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}
